<button mat-icon-button [matMenuTriggerFor]="themeMenu" class="theme-toggle-button" matTooltip="Switch Theme">
  <mat-icon>{{currentTheme === 'dark' ? 'dark_mode' : 'light_mode'}}</mat-icon>
</button>

<mat-menu #themeMenu="matMenu" class="theme-menu">
  <button mat-menu-item (click)="setTheme('light')" [class.active]="currentTheme === 'light'">
    <mat-icon>light_mode</mat-icon>
    <span>Light Theme</span>
    @if (currentTheme === 'light') {
    <mat-icon class="check-icon">check</mat-icon>
    }
  </button>
  <button mat-menu-item (click)="setTheme('dark')" [class.active]="currentTheme === 'dark'">
    <mat-icon>dark_mode</mat-icon>
    <span>Dark Theme</span>
    @if (currentTheme === 'dark') {
    <mat-icon class="check-icon">check</mat-icon>
    }
  </button>
</mat-menu>